/* eslint-disable react/prop-types */
import React from "react";

/**
 * ProposalHeader — co-branded header lockup + trust strip.
 *
 * Top row: MoveAbroadIQ wordmark + partner brand (logo or name) on the
 * right. Sticky on scroll so the brand stays present.
 *
 * Trust strip: small premium meta-badges directly under the header. Each
 * chip is generic enough to be safe defaults and conveys high-trust
 * positioning expected by international consulting clients (Confidential
 * · Tailored · Valid Through {expiry}). Auto-skips the expiry chip when
 * the proposal has no expires_at.
 */
function formatExpiry(dt) {
  if (!dt) return null;
  const d = new Date(dt);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "2-digit" });
}

export default function ProposalHeader({ proposal }) {
  const brand = proposal?.branding_snapshot || {};
  const logo = brand.company_logo_url;
  const name = brand.partner_name || brand.company_legal_name;
  const expiry = formatExpiry(proposal?.expires_at);

  return (
    <>
      <div className="miq-logo-row">
        <div className="miq-logo-row__brand">
          MoveAbroad<span>IQ</span>
        </div>
        {(logo || name) && (
          <div className="miq-logo-row__partner" data-testid="proposal-partner-brand">
            {logo ? <img src={logo} alt={name || "Partner"} /> : null}
            {!logo && name ? (
              <span style={{ color: "#0B1735", fontWeight: 700 }}>{name}</span>
            ) : null}
          </div>
        )}
      </div>

      <div className="miq-trust-strip" data-testid="proposal-trust-strip">
        <span className="miq-trust-chip">
          <span className="dot" />
          Confidential Proposal
        </span>
        <span className="miq-trust-chip">
          <span className="dot" />
          Tailored to your profile
        </span>
        <span className="miq-trust-chip gold">
          <span className="dot" />
          Advisor support included
        </span>
        {expiry && (
          <span className="miq-trust-chip">
            <span className="dot" />
            Valid through {expiry}
          </span>
        )}
      </div>
    </>
  );
}
